import { MappedCatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';

import type {
    AddItemsToOrderServiceDataGlobalItem,
    AddItemsToOrderServiceDataItem,
    AddItemsToOrderServiceParams,
} from '../model/types/addItemsToOrderSchema';

/**
 * Maps multiselect state to POST /v1/orders/:id/items body (bulk review / create order).
 * Each line is routed by **stored fields** (`catalogItemId` vs `uid`), not by UI tab.
 * Record **keys** are Redux selection keys; values hold wire ids for the API.
 */
export const buildBulkAddItemsDataFromSelection = (
    selectedItems: Record<string, Partial<MappedCatalogItem>>,
): AddItemsToOrderServiceParams['data'] => {
    const items: AddItemsToOrderServiceDataItem[] = [];
    const globalItems: AddItemsToOrderServiceDataGlobalItem[] = [];

    for (const [selectionMapKey, value] of Object.entries(selectedItems)) {
        const qty = value.qty ?? 0;
        if (value.catalogItemId != null && value.catalogItemId !== '') {
            items.push({ itemId: value.catalogItemId, qty });
        } else {
            globalItems.push({
                itemUuid: value.uid ?? selectionMapKey,
                qty,
            });
        }
    }

    const data: AddItemsToOrderServiceParams['data'] = {};

    if (items.length > 0) {
        data.items = items;
    }

    if (globalItems.length > 0) {
        data.globalItems = globalItems;
    }
    return data;
};

export type SingleAddItemCatalogSource =
    | 'catalog'
    | 'inventory'
    | 'marketplace';

/**
 * Maps a single add-to-order line to POST /v1/orders/:id/items body (checkbox quick-add).
 */
export const buildSingleAddItemData = (
    source: SingleAddItemCatalogSource,
    params: { itemId: string; qty: number },
): AddItemsToOrderServiceParams['data'] => {
    if (source === 'marketplace') {
        return {
            globalItems: [
                {
                    itemUuid: params.itemId,
                    qty: params.qty,
                },
            ],
        };
    }
    return {
        items: [
            {
                itemId: params.itemId,
                qty: params.qty,
            },
        ],
    };
};
